import { ActionBox as Container } from './styles'

export function AlertActions(props) {
  return <Container {...props} />
}
